import {getUserinfo, getLanguage} from './localStorage';
import React from 'react';
import io from 'socket.io-client';

const getInfoUser   = () => {
    const user      = getUserinfo();
    const userId    = (user && user.userId) ? user.userId : 0;
    const msisdn    = (user && user.msisdn) ? user.msisdn : "";
    const token     = (user && user.accessToken) ? `Bearer ${user.accessToken}` : "Bearer xyz";
    const name      = (user && user.fullname) ? user.fullname : "";
    const language      = getLanguage();
    return {
        userId,
        msisdn,
        token,
        name,
        language
    }
}
let {userId, msisdn, token, name, language}   = getInfoUser();

export const socket = io(process.env.REACT_APP_DOMAIN_SOCKET, { autoConnect: true, reconnection: true, reconnectionAttempts: 10,transports: ["websocket"], query: { token, userId, msisdn, room_id: 0, name, language }});

export const setSocketRoomId = async (room_id) => {
    let {userId, msisdn, token, name, language}       = getInfoUser();
    console.log('setSocketRoomId:', room_id, getInfoUser(), socket)
    if( socket.query.room_id == room_id && socket.query.userId == userId ){
        return;
    }
    socket.query.token      = token;
    socket.query.userId     = userId;
    socket.query.msisdn     = msisdn;
    socket.query.name       = name;
    socket.query.language       = language;
    socket.query.room_id    = room_id;
    socket.disconnect();//.connect();
    setTimeout(() => {
        socket.connect();
    }, 100)
}

export const SocketContext = React.createContext();